<template>
  <div class="column is-gapless is-12 columns is-paddingless-left is-paddingless-right is-multiline is-border-top has-bg-light">
    <div class="column is-10 is-padding-left is-padding-right">
      <div class="field">
        <r-label v-if='isRequired' :redCheck='true' :label="'Nom du package'" :value="newPrice.name"></r-label>
        <div class="control">
          <v-input :id="'sale_price' + idx" :name="'sale_price' + idx" :model="newPrice.name"
                  :v-validate="required" :errors-bag="errors" data-vv-value-path="val"
                  @input="val => newPrice.name = val" data-vv-as="Nom du package">
          </v-input>
        </div>
      </div>
    </div>
    <div class="column is-2 has-text-right is-padding-right">
      <label class="label">&nbsp;</label>
      <a @click="removeNewPrice(idx)" class="button is-square is-grey is-inverted is-border is-radiusless">
        <span class="icon"><i class="fal fa-trash-alt fa-lg has-text-grey"></i></span>
      </a>
    </div>
    <div class="column is-4 is-padding-left is-padding-right is-padding-top">
      <r-label v-if='isRequired' :label="prixHtName"  :redCheck='true' :value="newPrice.sale_price_ht"></r-label>
      <div class="field has-addons">
        <div class="control is-expanded">
          <v-input :id="'newPrice_sale_price_ht' + idx" :name="'newPrice_sale_price_ht' + idx" @input="val => newPrice.sale_price_ht = val" :model="newPrice.sale_price_ht"
                    input-type="number"
                    :v-validate="required" :errors-bag="errors" data-vv-value-path="val"
                    :number="true"
                    :data-vv-as="'Prix ' + newPrice.name + ' HT'">
          </v-input>
        </div>
        <div class="control">
          <a class="button is-static is-border is-min-width-0">
            <span class="icon is-small" :class="`is-currency-${$faCurrency}`"><i :class="`fas fa-${$faCurrency}-sign`"></i></span><span>HT</span>
          </a>
        </div>
      </div>
    </div>
    <div class="column is-2 is-padding-left is-padding-right is-padding-top">
      <div v-if="newPrice.sale_price_ht && newPrice.sale_price">
        <label class="label" for="tva">TVA</label>
        <div class="has-text-weight-bold has-text-black is-size-4">
          {{newPrice.sale_price_ht | tva(newPrice.sale_price) | prettyPrice}} %
        </div>
        <div class="has-text-weight-light has-text-black is-size-6">
          {{newPrice.sale_price - newPrice.sale_price_ht | prettyPrice}} {{$currency}}
        </div>
      </div>
    </div>
    <div class="column is-4 is-padding-left is-padding-right is-padding-top">
      <r-label v-if='isRequired' :redCheck='true' :label="prixTTCName" :value="newPrice.sale_price"></r-label>
      <div class="field has-addons">
        <div class="control is-expanded">
          <v-input :id="'newPrice_sale_price' + idx" :name="'newPrice_sale_price' + idx" @input="val => newPrice.sale_price = val"
                    :model="newPrice.sale_price" input-type="number"
                    :v-validate="required" :errors-bag="errors" data-vv-value-path="val"
                    :number="true"
                    :data-vv-as="'Prix ' + newPrice.name + ' TTC'">
          </v-input>
        </div>
        <div class="control">
          <a class="button is-static is-border is-min-width-0">
            <span class="icon is-small" :class="`is-currency-${$faCurrency}`"><i :class="`fas fa-${$faCurrency}-sign`"></i></span><span>TCC</span>
          </a>
        </div>
      </div>
    </div>
    <div class="column is-2 is-padding-left is-padding-right is-padding-top"></div>
    <div class="column is-10 is-padding-left is-padding-right is-padding-top">
      <label class="is-block has-text-grey is-size-7 is-margin-bottom-small is-uppercase">Détail de
        l'offre</label>
      <div class="field">
        <div class="control has-bg-white">
          <wysiwyg-editor :model="newPrice.description" placeholder="" :light='true'
                          @change="val => newPrice.description = val" :submited='isSubmited'
                          class="editr--bottom-toolbar editr--height-small content has-bg-white"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LotPrixPackage',
    props: {
      newPrice: {
        type: Object,
        required: true
      },
      idx: {
        type: Number,
        required: false
      },
      isSubmited: Boolean
    },
    data () {
      return {
        required: null
      }
    },
    computed: {
      isRequired () {
        if ((this.newPrice.name !== '' && this.newPrice.name !== null) || (this.newPrice.sale_price_ht !== '' && this.newPrice.sale_price_ht !== null) || (this.newPrice.sale_price !== '' && this.newPrice.sale_price !== null) || (this.newPrice.description !== '' && this.newPrice.description !== null)) {
          this.required = 'required'
          return true
        } else {
          this.required = ''
          return false
        }
      },
      prixHtName () {
        return 'Prix ' + this.newPrice.name + ' HT'
      },
      prixTTCName () {
        return 'Prix ' + this.newPrice.name + ' TTC'
      }
    },
    methods: {
      removeNewPrice (idx) {
        this.$emit('removeNewPrice', idx)
      }
    },
    created () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lot/LotPrixPackage.vue